
import type { RouteObject } from "react-router-dom";
import LandingPage from "../pages/landing/page";
import HvacPage from "../pages/hvac/page";
import FAQPage from "../pages/faq/page";
import PrivacyPage from "../pages/privacy/page";
import BlogPage from "../pages/blog/page";
import NotFound from "../pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <LandingPage />,
  },
  {
    path: "/hvac",
    element: <HvacPage />,
  },
  {
    path: "/faq",
    element: <FAQPage />,
  },
  {
    path: "/privacy",
    element: <PrivacyPage />,
  },
  {
    path: "/blog",
    element: <BlogPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
